/**
 * Import engine configuration constants
 * 
 * Centralizes configuration for import operations to ensure consistency
 * across the entire import system and eliminate duplication.
 */

/**
 * Maximum attachment file size in bytes (50MB)
 * 
 * Both CloudKit and Supabase have 50MB limits per file attachment.
 * This constant centralizes the size limit to ensure consistency
 * across all attachment validation logic.
 */
export const MAX_ATTACHMENT_SIZE_BYTES = 50 * 1024 * 1024 // 50MB
